
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService, Toast } from './toaster.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './toaster.component.scss',
  template: `
    <section class="toast-region" aria-live="polite" aria-atomic="false">
      @for (t of toastService.toasts(); track t.id) {
        <article
          class="toast"
          [class]="'toast type-' + t.type"
          [class.leaving]="t.leaving"
          [attr.role]="t.type === 'error' ? 'alert' : 'status'"
          (touchstart)="onTouchStart($event)"
          (touchmove)="onTouchMove($event)"
          (touchend)="onTouchEnd($event, t)"
        >
          <span class="icon" aria-hidden="true">
            @switch (t.type) {
              @case ('success') {
                <svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>
              }
              @case ('error') {
                <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>
              }
              @case ('warning') {
                <svg viewBox="0 0 24 24"><path d="M12 7v6M12 17h.01"/></svg>
              }
              @default {
                <svg viewBox="0 0 24 24"><path d="M12 11v6M12 7h.01"/></svg>
              }
            }
          </span>

          <div class="body">
            @if (t.title) { <strong class="title">{{ t.title }}</strong> }
            <p class="message">{{ t.message }}</p>
          </div>

          <button class="close" type="button" aria-label="إغلاق" (click)="toastService.dismiss(t.id)">
            <svg viewBox="0 0 24 24"><path d="M7 7l10 10M17 7L7 17"/></svg>
          </button>

          <span
            class="bar"
            [style.animation-duration.ms]="t.duration"
            (animationend)="toastService.dismiss(t.id)"
          ></span>
        </article>
      }
    </section>
  `,
})
export class ToastContainerComponent {
  toastService = inject(ToastService);

  private startX = 0;
  private startY = 0;
  private dx = 0;

  onTouchStart(e: TouchEvent) {
    this.startX = e.touches[0].clientX;
    this.startY = e.touches[0].clientY;
    this.dx = 0;
  }

  onTouchMove(e: TouchEvent) {
    const el = e.currentTarget as HTMLElement;
    this.dx = e.touches[0].clientX - this.startX;
    el.style.transition = 'none';
    el.style.transform = `translateX(${this.dx}px)`;
    el.style.opacity = String(1 - Math.min(Math.abs(this.dx) / 240, 0.8));
  }

  onTouchEnd(e: TouchEvent, t: Toast) {
    const el = e.currentTarget as HTMLElement;
    el.style.transition = '';
    if (Math.abs(this.dx) > 90) {
      this.toastService.dismiss(t.id);
    } else {
      el.style.transform = '';
      el.style.opacity = '';
    }
  }
}